import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@vr/lib';
import devices from '~/styles/devices';

const Item = styled.div`
  display: flex;
  align-items: center;
`;
const Icon = styled(FontAwesomeIcon)`
  font-size: 2.6rem;
  color: ${({ theme }) => theme.colors.secondary};
  margin-right: 20px;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
`;
const Label = styled.p`
  color: ${({ theme }) => theme.colors.gray400};
  font-size: 0.9rem;
  font-weight: 600;
`;
const Value = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.gray400};
  font-size: 1rem;
  font-weight: 700;

  @media (min-width: ${devices.tablet}) {
    font-size: 1.17rem;
  }
`;

export default function Contact({ data, type, ...props }) {
  const { href, label, value, icon } = data;
  return (
    <Item key={type} {...props}>
      <Icon icon={icon} />
      <Content>
        <Label>{label}</Label>
        <Value href={href}>{value}</Value>
      </Content>
    </Item>
  );
}

Contact.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};
